module.exports = "images/doc-service-add.407a3b05705e9dca61ddf7cdae127727.png";